import { OrganizationAircraftManagement } from "@/components/organization/OrganizationAircraftManagement";


const AircraftTypesPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <img src="/NAC_Icon_Only.png" alt="NAC Logo" className="h-8 w-8" />
          Aircraft Type Management
        </h1>
        <p className="text-muted-foreground mt-2">
          Manage aircraft types for your organization's flights
        </p>
      </div>

      <OrganizationAircraftManagement />
    </div>
  );
};

export default AircraftTypesPage;
